import { getApiClient } from "@punchup/utils";

import type { TixologiEventSnapshot } from "../../models/shows";
export type { TixologiEventSnapshot };

export interface AtomicBulkUpdateRequest {
  show_ids: string[]; // Punchup show IDs (parallel with event_ids)
  event_ids: number[]; // Tixologi event IDs (parallel with show_ids)
  venue_page_id: string; // For Tixologi token acquisition
  event_snapshots: TixologiEventSnapshot[]; // Current state for rollback
  // Fields to update (at least one required)
  name?: string;
  description?: string;
  start_time?: string; // HH:MM (24h)
  end_time?: string; // HH:MM (24h)
  door_time?: string | null; // HH:MM (24h) or null
  poster_img?: string | null;
  image_url?: string;
  tags_to_add?: number[]; // Tixologi tag IDs to add to each event
  tags_to_remove?: number[]; // Tixologi tag IDs to remove from each event
  comedian_ids?: string[]; // Ordered final lineup applied to every show ([] clears it)
}

export interface AtomicBulkUpdateResponse {
  updated: number;
  tixologi_failed_event_ids: number[];
  rollback_triggered: boolean;
  rollback_succeeded: boolean | null; // null if not triggered
  summary: {
    total: number;
    tixologi_succeeded: number;
    tixologi_failed: number;
    punchup_updated: number;
    tags_succeeded: number; // events whose tag changes all applied
    tags_failed: number; // events where at least one tag change failed
  };
}

export async function atomicBulkUpdateShows(
  data: AtomicBulkUpdateRequest
): Promise<AtomicBulkUpdateResponse> {
  return getApiClient()
    .put<{ data: AtomicBulkUpdateResponse }>("/api/v2/manager/shows/bulk", data)
    .then((res) => res.data);
}

export interface EventTimeSnapshot {
  event_id: number; // Tixologi event ID — required for the server-side rollback filter
  start_time: string; // ISO datetime (pre-update)
  end_time: string; // ISO datetime (pre-update)
}

export interface UpdateShowRequest {
  show_id: string;
  venue_page_id: string;
  tixologi_event_id: number;
  date: string; // YYYY-MM-DD
  start_time: string; // HH:MM (24h)
  end_time: string; // HH:MM (24h)
  event_snapshot: EventTimeSnapshot;
}

export interface UpdateShowResponse {
  success: boolean;
}

export async function updateShow(
  data: UpdateShowRequest
): Promise<UpdateShowResponse> {
  const { show_id, ...body } = data;
  return getApiClient()
    .put<{ data: UpdateShowResponse }>(`/api/v2/manager/shows/${show_id}`, body)
    .then((res) => res.data);
}
